import { IApiLogin } from 'affiny-core/modules/api/models/auth/auth.types';
import { IToken } from 'affiny-core/modules/auth/types';
import { AuthEndpoint } from '../affinyEndpoints/affiny.authEndpoint';

const ACCESS_TOKEN_URL = `/access_token/`;
const REFRESH_GRANT_TYPE = 'enc';
const PASSWORD_GRANT_TYPE = 'password';

export const AuthResource = {
  refreshWithToken: (
    refreshToken: string,
    sessionOrigin: string | null,
    blackbox?: string
  ) => {
    const body: Record<string, string> = {
      grant_type: REFRESH_GRANT_TYPE,
      enc: refreshToken,
    };

    if (blackbox) {
      body.blackbox = blackbox;
    }

    if (sessionOrigin) {
      body.session_origin = sessionOrigin;
    }

    return AuthEndpoint().url(ACCESS_TOKEN_URL).post(body).json<IToken>();
  },
  login: (
    username: string,
    password: string,
    captcha?: string,
    blackbox?: string
  ): Promise<IApiLogin> => {
    return AuthEndpoint()
      .url(ACCESS_TOKEN_URL)
      .headers(
        captcha
          ? {
              'x-captcha-response': captcha,
            }
          : {}
      )
      .post({
        blackbox,
        grant_type: PASSWORD_GRANT_TYPE,
        password,
        username,
      })
      .json<IApiLogin>();
  },
};
